<template>
    <div :class="[{'flipped': flipped, 'animate': animate}, 'wave']"></div>
</template>

<script>
export default {
    name: "Wave",
    props: {
        animate: {
            type: Boolean
        },
        flipped: {
            type: Boolean
        }
    }
};
</script>

<style scoped lang="scss">
.wave {
    -webkit-mask: url("~@/assets/wave.svg") repeat-x 0% 0%;
    mask: url("~@/assets/wave.svg") repeat-x 0% 0%;
    mask-size: auto;
}
.wave.animate {
    animation: wave 1.2s $curve;
}
.wave.flipped.animate {
    animation: wave-flipped 1.2s $curve;
}
.wave.flipped {
    transform: scaleY(-1);
    -webkit-mask: url("~@/assets/wave.svg") repeat-x 50% 0%;
    mask: url("~@/assets/wave.svg") repeat-x 50% 0%;
}

@keyframes wave {
    0% {
        mask-position: 75% 0%;
    }
    100% {
        mask-position: 0% 0%;
    }
}
@keyframes wave-flipped {
    0% {
        mask-position: -25% 0%;
    }
    100% {
        mask-position: 50% 0%;
    }
}
</style>